import React from "react";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import { createGlobalStyle } from "styled-components";
import Header from "../header";
import { Rating } from "react-simple-star-rating";
class Filter extends React.Component {
  state = {
    range: [5],
    score: "",
    value: "static",
    exists: 0,
    rate: 0,
    staticService: false,
    dynamicService: false,
    BothService: false,
    dynamicServiceValue: null,
    staticServiceValue: null,
    VendorHeader: true,
  };
  applyFilter() {
    const Data = [
      this.state.dynamicServiceValue,
      this.state.staticServiceValue,
      this.state.exists,
      this.state.rate,
      this.state.range,
    ];
    this.props.history.push({
      pathname: "/multiVendor",
      Filter: Data,
    });
  }
  exists_changed(payload) {
    this.setState({ exists: payload });
  }
  priceRange_changed(newRange) {
    this.setState({ range: newRange });
  }
  scoreChange(newRange) {
    this.setState({ score: newRange });
  }

  render() {
    const handleStaticServices = (e, id) => {
      this.setState(
        {
          staticService: true,
          dynamicService: false,
          BothService: false,
          staticServiceValue: id,
        },
        () =>
          this.state.staticService &&
          document
            .getElementsByClassName("staticService")[0]
            .classList.add("activeServiceMultiVendor"),
        document
          .getElementsByClassName("BothService")[0]
          .classList.remove("activeServiceMultiVendor"),
        document
          .getElementsByClassName("dynamicService")[0]
          .classList.remove("activeServiceMultiVendor"),
      );
    };
    const handleDynamicServices = (e, id) => {
      this.setState(
        {
          dynamicService: true,
          staticService: false,
          BothService: false,
          dynamicServiceValue: id,
        },
        () =>
          this.state.dynamicService &&
          document
            .getElementsByClassName("dynamicService")[0]
            .classList.add("activeServiceMultiVendor"),
        document
          .getElementsByClassName("BothService")[0]
          .classList.remove("activeServiceMultiVendor"),
        document
          .getElementsByClassName("staticService")[0]
          .classList.remove("activeServiceMultiVendor"),
      );
    };
    const handleBothServices = (e, id) => {
      this.setState(
        {
          dynamicService: false,
          staticService: false,
          BothService: true,
          dynamicServiceValue: id,
        },
        () =>
          this.state.BothService &&
          document
            .getElementsByClassName("BothService")[0]
            .classList.add("activeServiceMultiVendor"),
        document
          .getElementsByClassName("staticService")[0]
          .classList.remove("activeServiceMultiVendor"),
        document
          .getElementsByClassName("dynamicService")[0]
          .classList.remove("activeServiceMultiVendor"),
      );
    };
    const handleRating = (rate) => {
      this.setState({ rate: rate / 20 });
    };

    const GlobalStyles = createGlobalStyle`body{
            background: #F9F9F9;
          }`;
    return (
      <>
        <GlobalStyles />
        <Header
          showSearchBar={true}
          title={"فیلتر نتایج"}
          VendorHeader={this.state.VendorHeader}
        />
        <div className="FilterComMultiVendor">
          <div className="GeographicalDistance">
            <h1 className="titleReservationCom">محدوده فاصله</h1>
            <div className="value">
              <div className="MaxValue"> {this.state.range} کیلومتر </div>
              <div>تا</div>
              <div className="minValue">از 1 کیلومتر</div>
            </div>
            <Box width={300}>
              <Slider
                // size="small"
                defaultValue={70}
                onChange={(event, newValue) =>
                  this.priceRange_changed(newValue)
                }
                valueLabelDisplay="auto"
                max={5}
                min={1}
                color="secondary"
              />
            </Box>
          </div>
          <div className="Score">
            <h1 className="titleReservationCom">
              امتیاز کسب شده توسط سرویس کار
            </h1>
            <div className="scoreStarBox">
              <div className="RatingFilter">
                <Rating
                  className="garageFilterRating"
                  onClick={handleRating}
                  ratingValue={5}
                  fillColor={"#831f82"}
                  emptyColor={"#F6F2F8"}
                  iconsCount={5}
                  size={30}
                />
              </div>
              <div className="StarValue">
                <div className="MaxValue">امتیاز {this.state.rate} از 5</div>
              </div>
            </div>
          </div>
          <div className="serviceType">
            <h1 className="titleReservationCom">انتخاب نوع سرویس کار </h1>
            <div className="Services">
              <div
                className="staticService"
                onClick={(e) => handleStaticServices(e, "static")}
              >
                سرویس ثابت
                {this.state.staticService && (
                  <img src="/public/assets/icons/tick.svg" alt="pic" />
                )}
              </div>
              <div
                className="dynamicService"
                onClick={(e) => handleDynamicServices(e, "dynamic")}
              >
                سرویس سیار
                {this.state.dynamicService && (
                  <img src="/public/assets/icons/tick.svg" alt="pic" />
                )}
              </div>
              <div
                className="BothService"
                onClick={(e) => handleBothServices(e, "BothService")}
              >
                سرویس سیار و ثابت
                {this.state.BothService && (
                  <img src="/public/assets/icons/tick.svg" alt="pic" />
                )}
              </div>
            </div>
          </div>
          <div className="ApprovedByKachar">
            <div className="TXT">مورد تایید کاچار</div>
            <div className="shared">
              <div
                className={
                  this.state.exists === 1 ? "checkbox active" : "checkbox"
                }
                onClick={() =>
                  this.exists_changed(this.state.exists === 0 ? 1 : 0)
                }
              >
                <input type="checkbox"></input>
                <div className="toggler">
                  <div className="circleFilter"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="ApplyFilterMultiVendor"
          onClick={() => this.applyFilter()}
        >
          <button>اعمال فیلتر</button>
        </div>
      </>
    );
  }
}
export default Filter;
